import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAdminOutlets, delinkOutlet } from '../../../actions/outlet';
import PageTitle from '../../common/page-title';
import OutletSearch from './outlet-search';
import OutletTable from './outlet-table';

class OutletList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            query: "",
            pageNumber: 1
        }
    }

    componentWillMount() {
        this.getOutlets();
    }

    getOutlets(query = "", pageNumber = "") {
        const { dispatch } = this.props;

        dispatch(getAdminOutlets(query, pageNumber)).then(() => {
            this.setState({
                pageNumber: 1
            });
        });
    }

    handleChange(event) {
        this.setState({query: event.target.value});
    }

    handleClear() {
        this.setState({
            query: "",
            pageNumber: 1
        });
        this.getOutlets();
    }

    handleSearch() {
        this.getOutlets(this.state.query);
    }

    delinkOutlet(id) {
        const { dispatch } = this;

        dispatch(delinkOutlet(id));
    }

    handlePageChange = (page, size) => {
        this.setState({pageNumber:  page}, this.afterPageChange);
    };

    afterPageChange = () => {
        const { query, pageNumber } = this.state;

        this.props.dispatch(getAdminOutlets(query, pageNumber));
    };

    render() {
        return (
            <div className="container-fluid">
                <PageTitle>Outlets</PageTitle>
                <OutletSearch onSearch={(event) => this.handleSearch(event)}
                              onClear={(event) => this.handleClear()}
                              onChange={(event) => this.handleChange(event)}
                              searchValue={this.state.query}/>
                <OutletTable outlets={this.props.outlets}
                             handleDelink={this.delinkOutlet}
                             paging={this.props.paging}
                             onPageChange={this.handlePageChange}
                             currentPage={this.state.pageNumber}/>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        outlets: state.stores.stores,
        paging: state.stores.paging
    };
};

export default connect(mapStateToProps)(OutletList);



// WEBPACK FOOTER //
// ./src/components/admin/outlet-list/index.jsx